import React from 'react';
import request from '../../../request';
import Input from '../../shared/labelInput';

export default class AddUser extends React.Component {
  constructor() {
    super();
    this.state = {
      user: {},
      staffOnly: !this.admin,
      companies: [],
      selectedCompanies: [],
    };
  }

  async create() {
    let { match } = this.props;
    let { user } = this.state;
    console.log(match);
    try {
      this.setState({ loading: true });
      await request({
        url: `invites/create-user`,
        method: 'POST',
        body: {
          ...user,
          company_id: match.params.id,
        },
      });
      return this.setState({
        user: {},
        loading: false,
        error: 'User has been invited',
        selectedCompanies: [],
      });
    } catch (e) {
      this.setState({
        loading: false,
        error: e.message || e,
        user: { ...this.state.user, password: null, password_confirm: null },
      });
    }
  }

  render() {
    let {
      user,
      loading,
      error,
    } = this.state;

    return (
      <div id="dashboard" style={{ opacity: loading ? 0.5 : 1 }}>
        <h5 className="heading">Add User</h5>
        {error ? <p className="error">{error}</p> : null}
        <Input
          name="first_name"
          label="First Name"
          value={user.first_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          name="last_name"
          label="Last Name"
          value={user.last_name || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <Input
          id="email_field"
          name="email"
          label="Email"
          value={user.email || ''}
          onChange={e => this.setState({
            user: { ...user, [e.target.name]: e.target.value },
          })}
        />

        <div className="options">
          <button
            className="control_button"
            id="save"
            onClick={() => this.create()}
          >
            Save
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/companies/add-user.js